import type { FC } from "react";

import { LinearProgressBar } from "shared/Components";
import { Text } from "shared/uikit";
import { TextStylesEnum, TextVariantsEnum } from "shared/uikit/types";

import type { PaymentRequestAmountSummary } from "./amountSummary";

interface PaymentRequestProgressCellProps {
	summaries: PaymentRequestAmountSummary[];
}

const PaymentRequestProgressCell: FC<PaymentRequestProgressCellProps> = ({ summaries }) => (
	<div className="w-full flex flex-col gap-2">
		{summaries.map(summary => (
			<div key={summary.currency} className="w-full flex items-center gap-3">
				<Text variants={TextVariantsEnum.Caption3} className="w-12 shrink-0">
					{summary.progress}%
				</Text>
				<div className="flex-1 min-w-[120px]">
					<LinearProgressBar progress={summary.progress} />
				</div>
				{summaries.length > 1 && (
					<Text variants={TextVariantsEnum.Caption3} style={TextStylesEnum.Hint} className="w-8 shrink-0 uppercase">
						{summary.currency}
					</Text>
				)}
			</div>
		))}
	</div>
);

export default PaymentRequestProgressCell;
